<div class="ghost-merchant-bounty-list" *transloco="let t">
  <div class="instructions-section">
    <div class="instruction-step">
      <span class="step-number">1</span>
      <div class="step-content">
        <span class="step-title">{{ t('bounty.instructions.step1.title') }}</span>
        <span class="step-description">{{ t('bounty.instructions.step1.description') }}</span>
      </div>
    </div>

    <div class="instruction-step">
      <span class="step-number">2</span>
      <div class="step-content">
        <span class="step-title">{{ t('bounty.instructions.step2.title') }}</span>
        <span class="step-description">{{ t('bounty.instructions.step2.description') }}</span>
      </div>
    </div>

    <div class="instruction-step">
      <span class="step-number">3</span>
      <div class="step-content">
        <span class="step-title">{{ t('bounty.instructions.step3.title') }}</span>
        <span class="step-description">{{ t('bounty.instructions.step3.description') }}</span>
      </div>
    </div>
  </div>

  <div class="bounty-cards-container">
    @for (bounty of bounties(); track bounty.merchant.id) {
      <app-bounty-merchant-card [bounty]="bounty"></app-bounty-merchant-card>
    }
  </div>
</div>